import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const SortingArrowUpIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.33325 10L4.50825 11.175L9.16659 6.525V16.6667H10.8333V6.525L15.4833 11.1833L16.6666 10L9.99992 3.33333L3.33325 10Z"
            />
        </SvgIcon>
    );
};
